<template>
  <div class="card">
    <div class="bg-blue-light p-1">
      <TitleButton
          :showBtn="false"
          title="Performance Appraisal"
          btnTitle="Add New"
          :showAddNew="false"
      />
    </div>

    <div class="my-2 px-2">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4">
          <label class="align-middle">Appraisal Period <span class="required">*</span></label>
          <AsyncSelect
              placeholder="Select Appraisal Period"
              v-model="apprisalSetup"
              :autoSelectFirst="true"
              :api-service="fetchPerformanceApprisalSetupDropdown"
          />
        </div>
        <div class="col-sm-2 col-md-2 d-flex m-0 align-items-end action-btn-setter">
          <button
              style="min-width: 64px;"
              @click="getApprisalData"
              class="btn btn-primary btn-block waves-effect waves-float waves-light"
          >GO
          </button>
        </div>
      </div>

      <div class="col-12">
        <div class="d-flex justify-content-end px-2">
          <button
              @click="goToPrint"
              :disabled="loading"
              class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
          >
            Print
          </button>
        </div>
      </div>
    </div>

  </div>
  <hr>

   <PerformanceAppraisal
     :componentList="componentList"
     :groupChartData="groupChartData"
     :contactProfile="contactProfile"
     :apprisalData="apprisalData"
     :getApprisalData="getApprisalData"
     @getApprisalData="getApprisalData"
   />

  <Loader v-if="loading"/>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {inject, onMounted, reactive, ref, watch} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import handleDropDown from "@/services/modules/dropdowns";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleCompany from "@/services/modules/company";
import performanceAppraisalPdf from '@/services/utils/pdf/performanceAppraisalPdf';
import PerformanceAppraisal from '@/components/molecule/company/hrm-payroll/performance-appraisal/PerformanceAppraisal.vue';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const apprisalSetup = ref('')
const componentList = ref([])
const groupChartData = ref([])
const contactProfile = ref({})
const apprisalData = ref({})
const tableItems = ref([]);
const params = ref({
  offset: 10,
});
let companyInfo = reactive({})

const token = computed(() => localStorage.getItem('token'));

const {
  fetchUserPerformanceAppraisal,
} = handleHrPayroll()
const { fetchPerformanceApprisalSetupDropdown } = handleDropDown();
const { fetchCompanyInfo } = handleCompany();
const { exportToPDF } = performanceAppraisalPdf();

const getApprisalData = async () => {
  const query = getQuery();
  loading.value = true
  componentList.value = []
  groupChartData.value = []
  contactProfile.value = {}
  apprisalData.value = {}
  await fetchUserPerformanceAppraisal(query).then(res => {
    if (!res.status){
      return
    }
    componentList.value = res.data.component;
    groupChartData.value = res.data.group_chart_data;
    contactProfile.value = res.data.contact_profile;
    apprisalData.value = res.data.data;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const goToPrint = async () => {
  const query = getQuery();
  loading.value = true
  componentList.value = []
  groupChartData.value = []
  contactProfile.value = {}
  await fetchUserPerformanceAppraisal(query).then((res) => {
    if (!res.status) {
      return
    }
    componentList.value = res.data.component;
    groupChartData.value = res.data.group_chart_data;
    contactProfile.value = res.data.contact_profile;
  }).then(() => {
    exportToPDF(companyInfo, contactProfile.value, groupChartData.value, componentList.value)
  }).catch((err) => {
    console.log("Something went wrong");
  }).finally(() => {
    loading.value = false
  })
}

const setCompanyInfo = async () => {
  await fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo = res.data;
  }).catch((error) => {
    console.log(error);
  });
}


const getQuery = () => {
  let query = `?company_id=${route.params.companyId}`;
  if(apprisalSetup.value) query += `&performance_apprisal_setup_id=` + apprisalSetup.value.id
  return query;
}

watch(apprisalSetup, async (newVal) => {
  if (newVal) {
    await getApprisalData();
  }
}, { immediate: true });

onMounted(() => {
  setCompanyInfo()
})

</script>

<style>
.profile-info p{
  line-height: 1rem !important;
}
</style>